import AllCredentials from './AllCredentials';
import ApiCredentialDetails from './ApiCredentialDetails';

export const apiCredentialsPagesConfigs = [
  {
    path: '/api-credentials/all',
    element: <AllCredentials />,
  },
  {
    path: '/api-credentials/:id',
    element: <ApiCredentialDetails />,
  },
];
